export const headerText = "Pricing Breakdown";

export const vehicleSummaryColumns = [
  [
    { label: "Vehicle Type", key: "vehicleType" },
  ],
]

export const percentageSummaryColumns = [
  [
    { label: "Base Valuation", key: "baseValuation" },
    { label: "Base Percentage & Additional Percentage", key: "basePercentage", alternateLabel: "Base Percentage"},
  ],
]

export const monetarySummaryColumns = [
  [
    { label: "Calculated Value", key: "calculatedValue" },
    { label: "Additional Price Adjustment", key: "additionalAdjustment", hideIfNull: true},
    { label: "Calculated Value & Additional Price Adjustment", key: "effectOnPrice", hideIfNull: true},
  ]
]

export const finalPriceSummaryColumns = [
  [
    { label: "Final Price", key: "finalPrice" },
  ],
];

export const DETAILS_TEXT = "Details of Automatic Pricing for";

export const helpText = {
  BASE_PERCENTAGE:
    "Your automatic pricing base percentage and additional adjustments have been applied below.",
  FINAL_PRICE: "Adjustment using rounding rules",
};